<template>
  <div
    class="dashboard-stat-card bg-white pa-4 pb-0 rounded-lg position-relative overflow-hidden border border-blue-gray-100"
  >
    <div class="dashboard-stat-card__title-row d-flex align-center ga-2">
      <VIcon :icon="stat.icon" size="18" :color="stat.accentColor" />
      <span class="text-gray-500">{{ stat.title }}</span>
    </div>

    <div class="dashboard-stat-card__footer d-flex">
      <span class="dashboard-stat-card__value font-weight-bold">
        {{ toPersianDigits(stat.value) }}
      </span>
    </div>

    <svg
      class="dashboard-stat-card__wave position-absolute"
      width="245"
      height="83"
      viewBox="0 0 245 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g :filter="`url(#${waveFilterId})`">
        <path :d="DASHBOARD_STAT_CARD_WAVE_PATH" :fill="stat.waveColor" />
      </g>
      <defs>
        <filter
          :id="waveFilterId"
          x="-126"
          y="-2.86328"
          width="371"
          height="178.617"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.99900001287460327 0.99900001287460327"
            numOctaves="3"
            seed="3147"
          />
          <feDisplacementMap
            in="shape"
            scale="100"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_6936_15024">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { VIcon } from 'vuetify/components'
import {
  DASHBOARD_STAT_CARD_WAVE_PATH,
  getDashboardStatCardWaveFilterId,
} from './DashboardStatCard.constants'
import type { Props } from './DashboardStatCard.types'
import { toPersianDigits } from '@/modules/Reminder/utils/jalaliCalendar'

defineOptions({
  name: 'DashboardStatCard',
})

const props = defineProps<Props>()

const waveFilterId = computed(() =>
  getDashboardStatCardWaveFilterId(props.stat.id)
)
</script>

<style scoped lang="scss">
.dashboard-stat-card__title {
  color: rgb(var(--v-theme-gray-600));
  font-size: 14px;
  line-height: 20px;
}

.dashboard-stat-card__footer {
  margin-top: 12px;
  min-height: 39px;
  align-items: flex-start;
  justify-content: flex-start;
}

.dashboard-stat-card__value {
  color: rgb(var(--v-theme-gray-800));
  font-size: 32px;
  line-height: 39px;
}

.dashboard-stat-card__wave {
  inset-inline-end: 0;
  inset-block-start: 0;
  width: 100%;
  height: 108%;
  pointer-events: none;
}
</style>
